import { colorsBase, Theme } from '@coinbase/cdp-react';

import { AccentColorName } from '../types';

type BaseTheme = Pick<
  Theme,
  | 'colors-bg-default'
  | 'colors-bg-alternate'
  | 'colors-bg-primary'
  | 'colors-bg-secondary'
  | 'colors-fg-default'
  | 'colors-fg-muted'
  | 'colors-fg-primary'
  | 'colors-fg-onPrimary'
  | 'colors-fg-onSecondary'
  | 'colors-fg-positive'
  | 'colors-fg-negative'
  | 'colors-fg-warning'
  | 'colors-line-default'
  | 'colors-line-heavy'
>;

export const accentColorsLightMode: Record<AccentColorName, `#${string}`> = {
  blue: colorsBase.blue500,
  green: '#098551',
  orange: '#e1591b',
  pink: '#cb51bb',
  teal: '#0093cb',
};

export const accentColorsDarkMode: Record<AccentColorName, `#${string}`> = {
  blue: '#578bfa',
  green: '#27ad75',
  orange: '#ec8c68',
  pink: '#dd87d0',
  teal: '#68b4db',
};

export const lightTheme: BaseTheme = {
  'colors-bg-default': colorsBase.white,
  'colors-bg-alternate': colorsBase.gray100,
  'colors-bg-primary': accentColorsLightMode.blue,
  'colors-bg-secondary': colorsBase.gray100,
  'colors-fg-default': colorsBase.black,
  'colors-fg-muted': colorsBase.gray700,
  'colors-fg-primary': accentColorsLightMode.blue,
  'colors-fg-onPrimary': colorsBase.white,
  'colors-fg-onSecondary': colorsBase.black,
  'colors-fg-positive': colorsBase.green500,
  'colors-fg-negative': colorsBase.red500,
  'colors-fg-warning': colorsBase.amber500,
  'colors-line-default': colorsBase.gray200,
  'colors-line-heavy': colorsBase.gray500,
};

const darkModeBgAlt = '#22252d';

export const darkTheme: BaseTheme = {
  'colors-bg-default': colorsBase.black,
  'colors-bg-alternate': darkModeBgAlt,
  'colors-bg-primary': accentColorsDarkMode.blue,
  'colors-bg-secondary': darkModeBgAlt,
  'colors-fg-default': colorsBase.white,
  'colors-fg-muted': '#8a919e',
  'colors-fg-primary': accentColorsDarkMode.blue,
  'colors-fg-onPrimary': colorsBase.black,
  'colors-fg-onSecondary': colorsBase.white,
  'colors-fg-positive': '#27ad75',
  'colors-fg-negative': '#f0616d',
  'colors-fg-warning': colorsBase.amber500,
  'colors-line-default': '#252629',
  'colors-line-heavy': '#5a5d6a',
};
